/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can/util/util';
import Component from 'can/component/component';
import FeedService from 'scripts/services/base-feed-service';
import dtm from 'scripts/services/dtm';
import template from './broadcaster-search.stache';
import device from 'scripts/utils/device';
import appContext from 'scripts/app-context';

const broadcasterSearchUrl =
    window.globalSettings.feeds.schedule.broadcasterSearchUrl;

Component.extend({
    tag: 'broadcaster-search',
    template: template,
    viewModel: {
        emptyResult: false,
        define: {
            results: {
                type: 'array',
                value: [],
            },
        },
        setSearchValue: function(event) {
            let searchValue = can.trim($(event.target).val());
            this.attr('query', searchValue);

            if (searchValue) {
                let results = [];
                searchValue = searchValue.toLowerCase();

                this.attr('countries').map((country, index) => {
                    if (
                        country.country.toLowerCase().indexOf(searchValue) > -1
                    ) {
                        results.push(country);
                    }
                });
                this.attr('results', results);
                if (results.length > 0) {
                    this.attr('emptyResult', false);
                } else {
                    this.attr('emptyResult', true);
                }
            } else {
                this.attr('results', []);
            }
        },
        trackAnalytics: function() {
            dtm.trackInternationalBroadcast();
        },
    },
    events: {
        inserted(element) {
            this.viewModel.bind('scheduleDate', () => {
                this.viewModel.attr('query', '');
            });

            new FeedService({
                feedUrl: broadcasterSearchUrl,
                fromCache: false,
                autoUpdate: false,
            })
                .on('data', (type, data) => {
                    this.viewModel.attr('countries', data.countries);
                })
                .on('error', (error) => {
                    console.error(
                        'Error fetching live tv schedule data',
                        error,
                    );
                })
                .fetch();
        },

        '.s-input focus'(element, event) {
            const headerHeight = $(document)
                .find('.m-header')
                .height();
            const broadcasterSearch = element.closest('.c-broadcaster-search');
            this.viewModel.setSearchValue(event);
            if (device.isMobile && !device.isTablet && !device.isNative) {
                broadcasterSearch
                    .addClass('is-mobile-shown')
                    .css({ top: headerHeight });
                appContext.model.dispatch('page-scroll-toggle', [true]);
            }
        },

        '.s-input blur'() {
            if (!device.isMobile) {
                this.viewModel.attr('results', []);
                this.viewModel.attr('emptyResult', false);
            }
        },

        '.js-close click'(element) {
            const broadcasterSearch = element.closest('.c-broadcaster-search');
            broadcasterSearch.removeClass('is-mobile-shown');
            broadcasterSearch.css({ top: '' });
            appContext.model.dispatch('page-scroll-toggle', [false]);
            this.viewModel.attr('results', []);
            this.viewModel.attr('emptyResult', false);
        },
    },
});
